import React, { useState, useEffect, lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  change_Password_Api,
  setDefault_Change_Api_Key,
} from "../../../../../features/Api/changePasswordSlice";
import { setLoadingBarProgress } from "../../../../../features/LoadingBarSlice";
import { RenderLoadingSpinnerInImageTag } from "../../../Helper";
import { setRefreshTokenInValid } from "../../../../../features/UserLoginStatusSlice";
import { setDisplayAlertForRefreshInValid } from "../../../../../features/DisplayAlertRefreshInValidSlice";
import { useNavigate } from "react-router-dom";

// * import method different because its a lazy load import
const PasswordChangeServerResMsg = lazy(() =>
  import("../Components/PasswordChangeServerResMsg")
);

// import PasswordChangeServerResMsg from "../Components/PasswordChangeServerResMsg";

export default function ChangePassword(props) {
  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg, component_Key) {
    return (
      <Suspense
        key={component_Key}
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }
  const { uiBtn, modalHeading } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  // * Navigation on page
  const navigate = useNavigate();

  const apiCallForPasswordChange = () => {
    dispatch(setLoadingBarProgress({ progress: 50 }));
    dispatch(change_Password_Api());
    dispatch(setLoadingBarProgress({ progress: 70 }));
  };

  // # Password change redux state when api cal
  const changePassword_State = useSelector((state) => state.changePassword);
  const changePassword_Loading = changePassword_State.loading;
  const changePassword_Response = changePassword_State.response;
  const changePassword_StatusCode = changePassword_State.statusCode;

  // # set progress bar
  useEffect(() => {
    if (changePassword_Response !== null) {
      dispatch(setLoadingBarProgress({ progress: 80 }));
      dispatch(setLoadingBarProgress({ progress: 90 }));
      dispatch(setLoadingBarProgress({ progress: 100 }));
    }
  }, [changePassword_Response, dispatch]);

  // * Modal on/off function
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  //  * When modal is on the scroll is off
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = ""; // Re-enable scrolling
    }
    return () => {
      document.body.style.overflow = ""; // Re-enable scrolling when component unmounts
    };
  }, [isOpen]);

  // ! If refresh token invalid
  useEffect(() => {
    if (changePassword_StatusCode === 401) {
      dispatch(setRefreshTokenInValid()); // ? Common set refresh toke invalid
      dispatch(setDisplayAlertForRefreshInValid()); // ? Common display alert
      navigate("/login"); // ? Common Change Location
      window.location.reload(); // # Reloading the page to reset the application state.
    }
  }, [changePassword_StatusCode, dispatch, navigate]);
  return (
    <>
      {React.cloneElement(uiBtn, { onClick: toggleModal })}
      {isOpen && (
        <div className=" fixed inset-0  flex items-center justify-center z-50 bg-black/50  ">
          <div className=" modal-Scroll-Bar-Hide relative  space-y-4 bg-white px-6 py-10  shadow-2xl rounded-3xl w-10/12 sm:w-2/3 lg:w-2/4 xl:w-2/5 max-h-[90vh] overflow-y-scroll ">
            {/* Cross icon */}
            <div className=" absolute right-5 top-5 w-7 h-7 inline-flex justify-center items-center text-[#5c6c75] hover:text-black/90 hover:bg-[#e8edeb] rounded-full cursor-pointer ">
              <i
                onClick={() => {
                  toggleModal();
                  dispatch(setDefault_Change_Api_Key());
                }}
                className="ri-close-fill text-xl font-extrabold"
              ></i>
            </div>
            {/* Modak heading */}
            <div className="flex items-baseline space-x-3 ">
              <div className="flex items-center justify-center w-10 h-10 p-2 bg-[#ffa2002f] rounded-full">
                <i className="ri-arrow-up-down-fill text-Brand-Color text-lg"></i>
              </div>
              <h2 className="text-xl sm:text-2xl text-black font-serif  font-extrabold mb-2">
                {modalHeading}
              </h2>
            </div>
            <h3 className={`font-bold font-mono text-center text-black/75 `}>
              Protect Your Personal Information: Update Your Password
            </h3>
            <p className={` text-black/60 text-sm font-bold`}>
              As part of our commitment to maintaining a secure environment, we
              have implemented an email verification process to authenticate
              your identity. By following the link provided to, your Email will
              be directed to a secure page where you can update your password.
            </p>
            <button
              onClick={() => apiCallForPasswordChange()}
              className={` flex flex-wrap justify-center items-center text-sm font-bold font-mono bg-[#f9fbfa]  py-2 px-3 space-x-2 text-[#102c38] border border-[#102c38] rounded-lg shadow-inner hover:scale-90 ease-in-out duration-300 `}
            >
              <i
                className={` text-lg ${
                  !changePassword_Loading ? "ri-link" : "ri-loader-2-fill"
                }`}
              ></i>

              <h4>
                {!changePassword_Response
                  ? "Send verification link now?"
                  : "Send verification link again!"}
              </h4>
            </button>
            {/* Server response alert */}
            {returnComponentWithLazySetup(<PasswordChangeServerResMsg />, "")}
          </div>
        </div>
      )}
    </>
  );
}
